export default theme => ({
    footer: {
        width: "100%",
        padding: "15px 0",
        alignContent: "center",
        backgroundColor: theme.palette.background.default
    },
    footerImg: {
        width: "200px",
        display: "block",
        marginLeft: "auto",
        marginRight: "auto"
    },
    '@media all and (max-width: 600px)': {
        footerImg: {
            width: "200px",
        }
    }
})
